import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

@Component({ name: "SearchBox" })
export default class SearchBox extends Vue {
    public localizer: any = Localizer;
    public isLoading: boolean = false;
    public isCreated: boolean = true;
    public isAll: boolean = false;
    public searchtext: string = null;
    public resultIndex: number = -1;
    public results: any[] = [];
    public suggestions: any[] = [];
    public suggestionSearchList: any[] = [];
    public debounceTimeOut: any = null;
    public lockLoader: boolean = false;

    @Prop() readonly language: string;
    @Prop() readonly selectedArea: string;
    @Prop() readonly selectedCategory: string;
    @Prop() readonly selectedFamily: string;
    @Prop() readonly isList: boolean;
    @Prop() readonly iscatalogue: boolean;
    @Prop() readonly inputsearchtext: string;
    @Prop() readonly isHints: boolean;
    @Prop() readonly loadIndex: number;

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        this.searchtext = this.inputsearchtext;

        const outsideClickListener = event => {
            if (!this.$el.contains(event.target)) {
                this.results = [];
                this.suggestions = [];
                this.suggestionSearchList = [];
                this.resultIndex = -1;
                this.isCreated = true;
            }
        }

        document.addEventListener("click", outsideClickListener);
    }

    public onSearchtextChanged() {
        this.isCreated = false;
        this.debounceSearchtext(500);
    }

    public openDetailUrl(url: string, type) {
        GTagHelper.sendEvent("view_search_results", "region_search_to_detail", type);
        window.location.href = url;
    }

    public openDetailUrlByIndex() {
        if (this.resultIndex === -1 || this.suggestionSearchList.length === 0) {
            this.openResults();
        }

        if (this.results.length === 0) {
            this.setSearchText(this.suggestionSearchList.find(x => x.index === this.resultIndex)?.text);
            return;
        }

        window.location.href = this.suggestionSearchList.find(x => x.index === this.resultIndex).url;
    }

    public setSearchText(searchtext: string) {
        this.lockLoader = true;
        this.searchtext = searchtext;
        this.getSuggestions();
    }

    public async getSuggestions() {
        try {
            const response = (await Axios.post(this.routes.Region_Search_GetSuggestions, { searchtext: this.searchtext })).data;

            this.results = response.results;
            this.suggestions = response.suggestions;
            this.isAll = response.isAll;

            this.resultIndex = -1;

            if (this.results.length !== 0) {
                this.suggestionSearchList = this.results;
            }

            if (this.results.length === 0) {
                this.suggestionSearchList = this.suggestions;
            }

            for (let index = 0; index < this.suggestionSearchList.length; index++) {
                this.suggestionSearchList[index].index = index;
            }
        } catch (error) { }

        this.isLoading = false;
        this.lockLoader = false;
    }

    public async debounceSearchtext(delay: number) {
        if (!this.lockLoader) {
            this.isLoading = true;
        }

        const vm = this;
        clearTimeout(this.debounceTimeOut);
        this.debounceTimeOut = setTimeout(async function (context) {
            if (vm.searchtext && vm.searchtext.length >= 3) {
                await vm.getSuggestions();
            } else {
                vm.suggestionSearchList = [];
                vm.resultIndex = -1;
                vm.isLoading = false;
                vm.lockLoader = false;
            }
        }, delay, this);
    }

    public limitText(text: string, length: number) {
        if (text.length > length) {
            return text.substring(0, length) + "...";
        } else {
            return text;
        }
    }

    public openResults() {
        if (this.searchtext?.length > 2) {
            GTagHelper.sendEvent("view_search_results", "region_texture_suggestion", this.searchtext);
            window.location.href = this.routes.Region_Search_List + "?searchtext=" + this.searchtext;
        }
    }

    public resultMoveDown() {
        if (this.suggestionSearchList.length !== 0 && this.resultIndex < this.suggestionSearchList.length - 1) {
            this.resultIndex++;

            this.$nextTick(function () {
                this.checkIsInViewport();
            });
        }
    }

    public resultMoveUp() {
        if (this.suggestionSearchList.length !== 0 && this.resultIndex > 0) {
            this.resultIndex--;

            this.$nextTick(function () {
                this.checkIsInViewport();
            });
        }
    }

    public resetSearchtext() {
        this.searchtext = null;
        this.results = [];
        this.suggestions = [];
        this.suggestionSearchList = [];
        this.resultIndex = -1;
        this.isCreated = true;
    }

    public checkIsInViewport() {
        let myElement = document.querySelector(".item[data-selected='true']") ? document.querySelector(".item[data-selected='true']") : document.querySelector(".button[data-selected='true']");
        let box = document.querySelector(".results");

        if (!myElement || !box) return;

        const isInViewport = box.getBoundingClientRect().top >= 0 &&
            box.getBoundingClientRect().left >= 0 &&
            box.getBoundingClientRect().bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            box.getBoundingClientRect().right <= (window.innerWidth || document.documentElement.clientWidth);

        if (!isInViewport) {
            (<any>myElement).scrollIntoView({ behavior: "smooth", block: "center" });
            return;
        }

        const isVisible = function (myElement, box) {
            const { bottom, height, top } = myElement.getBoundingClientRect();
            const containerRect = box.getBoundingClientRect();

            return top <= containerRect.top ? containerRect.top - top <= height : bottom - containerRect.bottom <= height;
        };

        if (!isVisible(myElement, box)) {
            (<any>myElement).scrollIntoView({ behavior: "smooth", block: "center" });
        }
    }
};